import { Injectable } from '@angular/core';
import {
  CanDeactivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { Observable } from 'rxjs';
import { ConfirmationService } from 'primeng/api';

export interface ICanDeactivateWithUnsaved {
  hasUnsavedChanges(): boolean;
}

@Injectable()
export class GuardUnsavedFormService implements CanDeactivate<ICanDeactivateWithUnsaved> {
  constructor(private confirmationService: ConfirmationService) {}

  canDeactivate(
    component: ICanDeactivateWithUnsaved,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): boolean | Observable<boolean> {
    if (!component || !component.hasUnsavedChanges()) {
      return true;
    }
    return new Observable<boolean>(observer => {
      this.confirmationService.confirm({
        key: 'unsaved-form',
        message: 'Вы уверены, что хотите уйти? Изменения не сохранены.',
        header: 'Подтверждение',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Уйти',
        rejectLabel: 'Остаться',
        acceptButtonStyleClass: 'ui-buttons ui-buttons__blue-small',
        rejectButtonStyleClass: 'ui-buttons ui-buttons__light-small',
        accept: () => {
          observer.next(true);
          observer.complete();
        },
        reject: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }
}
